'use client';

import { I18nProvider as LinguiProvider } from '@lingui/react';
import { i18n } from '@/lib/i18n';

export function I18nProvider({ children }: { children: React.ReactNode }) {
  return <LinguiProvider i18n={i18n}>{children}</LinguiProvider>;
}
